import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import RadioButton from 'react-uwp/RadioButton';
import MaterialInput from 'components/form/MaterialInput/MaterialInput';

import './ContentSourceSurvey.style.scss';

// `detail` is the optional follow-up question shown under the option when it is selected.
export const SOURCE_OPTIONS = [
  { value: 'Indicação de outro piloto ou amigo' },
  { value: 'Escola de aviação ou aeroclube', detail: 'Qual o nome da escola ou aeroclube?' },
  { value: 'Instrutor de voo' },
  { value: 'Influenciador ou criador de conteúdo', detail: 'Qual o nome do influenciador ou creator?' },
  { value: 'Instagram ou outra rede social' },
  { value: 'Google ou outra busca na internet' },
  { value: 'Evento de aviação', detail: 'Qual evento?' },
  { value: 'Empresa ou local onde trabalho' },
  { value: 'Já conhecia a NexAtlas há algum tempo' },
  { value: 'Outro', detail: 'Conta pra gente como conheceu.' },
];

export const hasDetail = option => SOURCE_OPTIONS.some(o => o.value === option && o.detail);

const ContentSourceSurvey = props => {
  const { option, detail, onChangeOption, onChangeDetail } = props;

  const detailRef = useRef(null);

  // The follow-up input can appear below the fold of the scrolling content (e.g. "Outro", the last row).
  useEffect(() => {
    if (detailRef.current && detailRef.current.scrollIntoView) {
      detailRef.current.scrollIntoView({ block: 'nearest' });
    }
  }, [option]);

  return (
    <div className="auth__source-survey">
      <p className="auth__source-survey__intro">Queremos entender como os pilotos chegam até nós. Leva só alguns segundos.</p>
      <div className="auth__source-survey__label">Selecione uma opção:</div>
      <div className="auth__source-survey__options">
        {SOURCE_OPTIONS.map(({ value, detail: detailQuestion }) => (
          <React.Fragment key={value}>
            {/* The whole row is clickable: react-uwp only listens for clicks on the radio circle. */}
            <div className="auth__source-survey__option" onClick={() => onChangeOption(value)} role="presentation">
              <RadioButton defaultChecked={option === value} label={value} onCheck={() => onChangeOption(value)} />
            </div>
            {option === value && detailQuestion && (
              <div ref={detailRef} className="auth__source-survey__detail">
                <MaterialInput name="sourceDetail" label={detailQuestion} value={detail} onChangeValue={onChangeDetail} />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

ContentSourceSurvey.defaultProps = {
  option: null,
  detail: null,
};

ContentSourceSurvey.propTypes = {
  option: PropTypes.string,
  detail: PropTypes.string,
  onChangeOption: PropTypes.func.isRequired,
  onChangeDetail: PropTypes.func.isRequired,
};

export default ContentSourceSurvey;
